// extracted by mini-css-extract-plugin
export var grid = "_11-0";
export var span1 = "_11-2";
export var span10 = "_11-b";
export var span10L = "_11-z";
export var span10M = "_11-n";
export var span10Xl = "_11-1b";
export var span11 = "_11-c";
export var span11L = "_11-10";
export var span11M = "_11-o";
export var span11Xl = "_11-1c";
export var span12 = "_11-d";
export var span12L = "_11-11";
export var span12M = "_11-p";
export var span12Xl = "_11-1d";
export var span1L = "_11-q";
export var span1M = "_11-e";
export var span1Xl = "_11-12";
export var span2 = "_11-3";
export var span2L = "_11-r";
export var span2M = "_11-f";
export var span2Xl = "_11-13";
export var span3 = "_11-4";
export var span3L = "_11-s";
export var span3M = "_11-g";
export var span3Xl = "_11-14";
export var span4 = "_11-5";
export var span4L = "_11-t";
export var span4M = "_11-h";
export var span4Xl = "_11-15";
export var span5 = "_11-6";
export var span5L = "_11-u";
export var span5M = "_11-i";
export var span5Xl = "_11-16";
export var span6 = "_11-7";
export var span6L = "_11-v";
export var span6M = "_11-j";
export var span6Xl = "_11-17";
export var span7 = "_11-8";
export var span7L = "_11-w";
export var span7M = "_11-k";
export var span7Xl = "_11-18";
export var span8 = "_11-9";
export var span8L = "_11-x";
export var span8M = "_11-l";
export var span8Xl = "_11-19";
export var span9 = "_11-a";
export var span9L = "_11-y";
export var span9M = "_11-m";
export var span9Xl = "_11-1a";
export var stretch = "_11-1";